import axios from 'axios';
import { MediaActionTypes } from './';

const endpoint = `${process.env.REACT_APP_ERP_API_HOST}/media`;

export function uploadMedia(file, folder, callback, errorCallback) {

  let formData = new FormData();

  formData.append('files', file);
  formData.append('folder', folder);

  const request = axios.post(`${endpoint}/upload`, formData);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }
  
  return {
    type: MediaActionTypes.UPLOAD,
    payload : request
  };
}



// WEBPACK FOOTER //
// ./src/actions/media.action.js